import { render, staticRenderFns } from "./Dissertation_council_scientific_field.vue?vue&type=template&id=59fd23ae&scoped=true"
import script from "./Dissertation_council_scientific_field.vue?vue&type=script&lang=js"
export * from "./Dissertation_council_scientific_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd23ae",
  null
  
)

export default component.exports